import React from 'react';
import './AttemptedWords.css';

interface AttemptedWordsProps {
  attempts: string[];
}

const AttemptedWords: React.FC<AttemptedWordsProps> = ({ attempts }) => {
  return (
    <div className="attempted-words-container">
      <h3 className="attempted-words-title">❌ Failed Attempts</h3>
      <div className="attempted-words-list">
        {attempts.length === 0 ? (
          <p className="attempted-words-empty">No failed attempts yet</p>
        ) : (
          attempts.map((word, index) => (
            <span 
              key={`${word}-${index}`} 
              className="attempted-word"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              {word}
            </span>
          ))
        )}
      </div>
    </div>
  );
};

export default AttemptedWords;
